<template>
  <div
    id="inquiry-form"
    :style="getBackgroundColor"
    class="uk-margin-top uk-margin-large-bottom"
  >
    <div
      style="max-width:100%;"
    >
      <div class="tw-text-small uk-margin-small-top tw-text-muted">

        <div>
          <div v-if="showDebug || isDev">
            <Alert type="warning">
              <h3>Test- und Entwicklermodus</h3>
              <div>
                Env: {{ env }}
              </div>
              <strong>{{ getType }}: {{ formInfo }}<br></strong>
              Anfrage: {{ inquiry.id }} / {{ inquiry.token }}
              <div v-if="poolInfo && poolInfo.name">
                Pool: {{ poolInfo.name }}
              </div>
            </Alert>
            <div v-if="apiError">
              <Alert type="error">
                Fehler:
                <pre>
                  {{ apiError }}
                </pre>
              </Alert>
            </div>
          </div>
          <Form
            class="tw-margin-small-top"
          >
            <component
              :is="getPageComponent"
              @on-validated="validated"
            />
          </Form>
        </div>
      </div>
      <div>
        <NavButtons
          :is-saving="isSaving"
          :page-name="getPage"
          :page-index="pageIndex"
          @on-next-page="nextPage"
          @on-prev-page="prevPage"
        />
      </div>
    </div>
    <div
      class="uk-text-smallest uk-text-muted"
      @dblclick="showDebug = !showDebug"
    >
      {{ version }}
    </div>
  </div>
</template>
<script>
import ElasticFrame from 'elasticframe'
import { mapState } from 'vuex'

import Home from './Home'
import Message from './Message'
import Extras from './Extras'
import Complete from './Complete'
import Summary from './Summary'
import pjson from '../../package.json'

import NavButtons from './NavButtons'

export default {
  components: {
    Home,
    Extras,
    Message,
    NavButtons,
    Complete,
    Summary
  },
  props: {
    aid: {
      type: Number,
      default: null
    },
    bgColor: {
      type: String,
      default: 'fff'
    },
    formToken: {
      type: String,
      default: ''
    },
    japi: {
      type: String,
      default: 'production'
    },
    params: {
      type: null,
      default: null
    },
    formWidth: {
      type: Number,
      default: 600
    },
    inquiryToken: {
      type: String,
      default: ''
    },
    departure: {
      type: String,
      default: ''
    },
    langCode: {
      type: String,
      default: null
    },
    arrival: {
      type: String,
      default: null
    },
    modalVisible: {
      type: Boolean,
      default: null
    },
    modalTitle: {
      type: String,
      default: 'Unverbindliche Anfrage'
    }
  },
  data () {
    return {
      pages: ['Home', 'Message', 'Complete', 'Summary'],
      status: null,
      isSaving: false,
      version: pjson.version,
      showDebug: false
    }
  },
  computed: {
    getPage () {
      return this.pages[this.pageIndex]
    },
    getPageComponent () {
      return this.getPage
    },
    ...mapState({
      pageIndex: state => state.store.pageIndex,
      offer: state => state.store.offer,
      inquiry: state => state.store.inquiry,
      extras: state => state.store.extras,
      numberOfPages: state => state.store.numberOfPages,
      validationErrors: state => state.store.validationErrors,
      isComplete: state => state.store.isComplete,
      form: state => state.store.form,
      apiError: state => state.store.error,
      poolInfo: state => state.store.poolInfo,
      formInfo: state => state.store.formInfo
    }),
    getBackgroundColor () {
      return {
        backgroundColor: '#' + this.bgColor
      }
    },
    getType () {
      const types = ['Unterkunftseintrag', 'Poolformular', 'Websiteformular', 'Manueller Tausch', 'Angebot']
      return types[this.inquiry.type - 1]
    },
    env () {
      return process.env.NODE_ENV
    },
    isDev () {
      return (process.env.NODE_ENV === 'development')
    }
  },
  watch: {
    async 'extras.length' (len) {
      if (this.inquiry.type === 3) {
        if (len) {
          this.pages = ['Home', 'Extras', 'Message', 'Complete', 'Summary']
        }
      } else {
        this.pages = ['Home', 'Message', 'Complete', 'Summary']
      }
    },
    'offer' () {
      this.iFrame.resize()
    },
    'inquiry.is_late_exchange' (val) {
      if (val === 1) {
        this.pages = ['Home', 'Message', 'Complete', 'Summary']
        const page = this.pages.findIndex(item => item === 'Summary')
        this.$store.commit('setPage', page)
      }
    }
  },
  async mounted () {
    this.iFrame = ElasticFrame.initIframe()
    if (this.inquiry.type === 3 && this.extras.length) {
      this.pages = ['Home', 'Extras', 'Message', 'Complete', 'Summary']
    } else {
      this.pages = ['Home', 'Message', 'Complete', 'Summary']
    }
    this.iFrame.resize()
  },
  methods: {
    async nextPage () {
      this.isSaving = (this.getPage === 'Home' && !this.inquiry.id)
      await this.$bus.$emit('validate-data', this.getPage)
    },
    async prevPage () {
      if (this.getPage === 'Summary') {
        this.$store.commit('setPage', 1)
      }
      if (this.getPage === 'Message' && !this.extras.length) {
        this.$store.commit('setPage', 0)
      }
      window.scrollTo(0, 0)
      this.iFrame.resize()
      this.$store.commit('prevPage')
    },
    update () {
      window.scrollTo(0, 0)
      this.iFrame.resize()
    },
    async validated (page) {
      this.isSaving = false
      if (this.getPage === 'Message' || this.getPage === 'Summary') {
        this.isSaving = true
        await this.$store.dispatch('saveInquiry', true)
        this.isSaving = false

        if (process.env.NODE_ENV === 'development') {
          console.log('COMPLETE')
          const page = this.pages.findIndex(item => item === 'Complete')
          this.$store.commit('setPage', page)
          this.update()
        } else {
          if (this.form && this.form.thanks_url) {
            window.top.location.href = this.form.thanks_url
          } else {
            location.replace(process.env.VUE_APP_THANKS_URL + '/' + this.inquiry.token)
          }
        }
      }

      if (this.inquiry.type === 3 && this.extras.length) {
        if (this.getPage === 'Summary') {
          this.$store.commit('setPage', 3)
        } else {
          this.$store.commit('nextPage')
        }
      } else {
        switch (this.getPage) {
          case 'Home':
            this.$store.commit('setPage', 1)
            break
          case 'Message':
            this.$store.commit('setPage', 3)
            break
          case 'Summary':
            this.$store.commit('setPage', 3)
            break
          default:
            this.$store.commit('nextPage')
        }
      }

      this.update()
    }
  }
}
</script>
